import { List, ListItem } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

export function SimpleErrorFormatter(props) {
    const bespokeErrorFormatterTextClassname = "text-error-800 text-sm";
    return (
      <div className={props.className ?? ""}>
        {props.validationErrors?.length > 0 &&
        <List id={props.id ?? null}>
          {props.validationErrors
          .filter((error)=>React.isValidElement(error))
          .map((validationError, index) => {
            return (
              <span key={index}>
              <ListItem key={index}>
                <p className={bespokeErrorFormatterTextClassname}>
                  {validationError}
                </p>
              </ListItem>
              </span>
            )
          })
          }
        </List>
        }
      </div>
    )
  }
  SimpleErrorFormatter.propTypes = {
    validationErrors: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    id: PropTypes.string,
  }